// src/ryan/components/RyanTestModeBadge.tsx
//
// Indicador visível de "modo teste" em RyanProductPage.tsx/RyanCheckoutPage.tsx
// — só aparece quando isOptedOut() é true (ver ryanAnalytics.ts), pra nunca
// deixar em dúvida se o rastreamento está desligado. Clicável: religa o
// rastreamento na hora, sem precisar voltar pro admin — mas a fonte de
// verdade pra LIGAR o opt-out continua sendo o toggle do admin (aqui só dá
// pra desligar, não religar por engano visitando a própria página pública).
import React, { useEffect, useState } from 'react';
import { isOptedOut, setOptedOut } from '../utils/ryanAnalytics';
import './RyanTestModeBadge.css';

const RyanTestModeBadge: React.FC = () => {
    const [optedOut, setOptedOutState] = useState(false);

    useEffect(() => {
        setOptedOutState(isOptedOut());
    }, []);

    if (!optedOut) return null;

    return (
        <button
            type="button"
            className="rtmb-badge"
            onClick={() => { setOptedOut(false); setOptedOutState(false); }}
            title="Suas visitas não estão sendo contadas no analytics. Clique pra rastrear normalmente."
        >
            🧪 Modo teste — não rastreado <span className="rtmb-action">rastrear mesmo assim</span>
        </button>
    );
};

export default RyanTestModeBadge;
